import { faFileAlt } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Table, Typography } from "antd"
import dayjs from "dayjs"
import { centsToDollarsDisplay } from "../displayFormatters"
import { CustomerInvoiceRow } from "./customerApi"
import { useCustomerInvoicesQuery } from "./customerQueries"

const { Text } = Typography

const formatDate = (value?: string | null) => (value ? dayjs(value).format('MMM D, YYYY') : '')

type Props = {
  customerId: number
}

const CustomerIssuedInvoices = ({ customerId }: Props) => {
  const invoicesQuery = useCustomerInvoicesQuery(customerId)

  return <section>
    <Text strong><FontAwesomeIcon icon={faFileAlt} /> Issued Invoices</Text>
    <Table<CustomerInvoiceRow>
      rowKey={(_, index) => String(index)}
      dataSource={invoicesQuery.data ?? []}
      loading={invoicesQuery.isLoading}
      pagination={false}
      size="small"
      style={{ marginTop: 12 }}
      columns={[
        { title: 'Invoice Date', key: 'invoiceDate', render: (_, inv) => formatDate(inv.createDate) },
        { title: 'Project Name', key: 'projectName', render: (_, inv) => inv.project?.name },
        { title: 'Due Date', key: 'dueDate', render: (_, inv) => formatDate(inv.dueDate) },
        { title: 'Amount', key: 'amount', render: (_, inv) => centsToDollarsDisplay(inv.amount) },
      ]}
    />
  </section>
}

export default CustomerIssuedInvoices
